import { render, staticRenderFns } from "./PendingEvaluations.vue?vue&type=template&id=46b26bb7&"
import script from "./PendingEvaluations.vue?vue&type=script&lang=js&"
export * from "./PendingEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports